import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModalModule } from '@ng-bootstrap/ng-bootstrap';
import { HomeComponent } from '../../home/home.component';
import { AboutComponent } from '../../about/about.component';
import { SharedModule } from '../../shared/shared.module';
import { DefaultComponent } from './default.component';
import { RouterModule } from '@angular/router';
import { OwlModule } from 'ngx-owl-carousel';
import { AuthenticationComponent } from '../../authentication/authentication.component';
import { OrdersComponent } from '../../orders/orders.component';
import { ProductsComponent } from '../../products/products.component';
import { ProductComponent } from '../../products/product/product.component';
import { ProjectsComponent } from '../../projects/projects.component';
import { ProjectComponent } from '../../projects/project/project.component';
import { ContactComponent } from '../../contact/contact.component';
import { BlogsComponent } from '../../blogs/blogs.component';
import { PostComponent } from '../../blogs/post/post.component';
import { CartComponent } from '../../cart/cart.component';
import { CheckOutComponent } from '../../check-out/check-out.component';
import { SignupComponent } from '../../signup/signup.component';
import { ForgotPasswordComponent } from '../../forgot-password/forgot-password.component';
import { CartService } from '../../shared/services/cart.service';
import { ProductService } from '../../shared/services/product.service';
import { FilterService } from '../../shared/services/filter.service';
import { AngularFireAuthModule } from '@angular/fire/auth';
import { AngularFireModule } from '@angular/fire';
import { environment } from '../../../environments/environment';
import { AngularFireDatabaseModule } from '@angular/fire/database';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { CalculatorComponent } from '../../calculator/calculator.component';
import { NouisliderModule } from 'ng2-nouislider';
import { FormsModule } from '@angular/forms';
import { CalculatedResultComponent } from '../../calculator/calculated-result/calculated-result.component';
import { ReferAppComponent } from '../../refer-app/refer-app.component';
import { ReferProductComponent } from '../../refer-product/refer-product.component';
import { ReplacementComponent } from '../../replacement/replacement.component';
import { TrackOrderComponent } from '../../track-order/track-order.component';
import { RateProductComponent } from '../../rate-product/rate-product.component';
import { ServicesComponent } from '../../services/services.component';

@NgModule({
  declarations: [
    DefaultComponent,
    HomeComponent,
    AboutComponent,
    OrdersComponent,
    ProductsComponent,
    ProductComponent,
    ProjectsComponent,
    ProjectComponent,
    BlogsComponent,
    ContactComponent,
    PostComponent,
    CartComponent,
    CheckOutComponent,
    AuthenticationComponent,
    SignupComponent,
    ForgotPasswordComponent,
    CalculatorComponent,
    CalculatedResultComponent,
    ReferAppComponent,
    ReferProductComponent,
    ReplacementComponent,
    TrackOrderComponent,
    RateProductComponent,
    ServicesComponent
  ],
  imports: [
    OwlModule,
    NgbModalModule,
    CommonModule,
    RouterModule,
    SharedModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    AngularFirestoreModule,
    NouisliderModule,
    FormsModule
  ]
})
export class DefaultModule { }
